import DOMPurify from "dompurify";

const Header = (props) => {
  const style = {
    backgroundImage: "url(" + props.data.img + ")",
  };
  return (
    <div className="pt-8 md:pt-16">
      <div
        id="header"
        style={style}
        className="md:mx-5 h-[20rem] sm:h-[25rem] md:h-[45rem]  bg-cover"
      >
        <div
          id="headerGradiant"
          className="flex items-end pl-10 pb-0 md:pb-10 pt-0 pr-0 md:rounded-3xl h-full"
        >
          <div className="flex flex-row justify-between gap-4 pb-10 w-full text-white ">
            {/*grid grid-cols-1 md:grid-cols-2*/}
            <div className="">
              <div id="aboutus"></div>
              <h1 className="text-sm sm:text-xl md:text-4xl font-bold">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.part1.title),
                  }}
                />
              </h1>
              <h3 className="text-xs md:text-xl hidden sm:flex pt-4">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.part1.desc),
                  }}
                />
              </h3>
              <div className="flex md:hidden gap-4 mt-4">
                <a href={props.data.part2.googlePlayLink}>
                  <img
                    className="hover:opacity-50 w-20 sm:w-24 md:w-40 place-self-end"
                    src={props.data.part2.googlePlayImg}
                    alt="no img"
                  />
                </a>
                <a href={props.data.part2.appStoreLink}>
                  <img
                    className="hover:opacity-50 w-20 sm:w-24 md:w-40"
                    src={props.data.part2.appStoreImg}
                    alt="no img"
                  />
                </a>
              </div>
            </div>
            <div className="hidden md:grid mr-10">
              {/* col-start-2 */}
              <h1 className=" flex text-2xl place-self-center py-4">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.part2.title),
                  }}
                />
              </h1>
              <div className="grid grid-cols-2 gap-4">
                <a href={props.data.part2.googlePlayLink}>
                  <img
                    className="hover:opacity-50 w-24 md:w-40 place-self-end"
                    src={props.data.part2.googlePlayImg}
                    alt="no img"
                  />
                </a>
                <a href={props.data.part2.appStoreLink}>
                  <img
                    className="hover:opacity-50 w-24 md:w-40"
                    src={props.data.part2.appStoreImg}
                    alt="no img"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
